import React, { useState, useRef, useEffect } from "react";
import AjaxHandler from "../../commons/ajax/AjaxHandler.js";
import Config from "../../commons/config/Config.js";
import ConfigBusiness from "../../commons/config/ConfigBusiness.js";
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Tooltip,
  TablePagination,
  Collapse,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import Select from 'react-select'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { StyledTableCell } from "../../commons/utils/TableStyles";
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import 'moment/min/locales'
import LocaleFormat from '../../commons/utils/LocaleFormat.js'


const sendData = (service, data) => {
  let serviceURL = Config.get("apiUrlBase") + service;
  return fetch(serviceURL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Authorization-Token": localStorage.getItem("token"),
    },
    body: JSON.stringify(data),
  });
};

const ajaxHandler = new AjaxHandler();

const CambioCentroCostoMovil = (props) => {
  // El `intl` VIENE POR PROP y no de useIntl(): sweetalert2-react-content monta este componente
  // en un contenedor propio, fuera del árbol de React, así que acá no hay ningún <IntlProvider>
  // de ancestro y el hook tira "Could not find required `intl` object". Lo inyecta cada
  // consumidor, que sí está en el árbol.
  const intl = props.intl;
  const formRef = useRef();
  useEffect(() => {}, []);

  const [centroCosto, setCentroCosto] = useState(props.id);
  const [fecha, setFecha] = useState(moment());
  const [razon, setRazon] = useState('');
  const [comentario, setComentario] = useState('');
  const [centrosCosto, setCentrosCosto] = useState(props.CECOs);
  const [guardando, setGuardando] = useState(false);
  // Era `useState(props.dominio)`, que devuelve el par [valor, setter]: al backend le viajaba el
  // ARRAY como dominio, no el string.
  const dominio = props.dominio;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (guardando) return;

    let data = {
      // El ABM identifica el móvil por dominio; la grilla (VEC-3572) manda además el id, que el
      // backend prioriza. Cada pantalla usa lo que tiene y el endpoint es el mismo.
      id : props.movilId,
      dominio : dominio,
      centroCosto : centroCosto,
      fecha : fecha.format(),
      razon : razon,
      comentario : comentario
    }

    setGuardando(true);
    sendData("/moviles/actualizar/centrocosto", data)
    .then((response) => {
      // Antes se llamaba a props.success() dentro del .then del json() pasara lo que pasara: el
      // 409 que devuelve este endpoint ante cualquier error pintaba "actualizado con éxito", y la
      // pantalla mostraba un cambio que el backend había rechazado.
      return response.json().then((body) => {
        if (!response.ok) {
          // Si el backend explica el error se muestra tal cual; si no, un texto propio. El
          // mensaje se traduce ACÁ porque quien lo muestra (Dialog.alert) recibe el texto ya
          // resuelto y no puede saber de qué key vino.
          const detalle = body && body.mensaje
            ? intl.formatMessage({ id: body.mensaje, defaultMessage: body.mensaje })
            : intl.formatMessage({
                id: 'cambioCentroCostoMovil.mensaje_error',
                defaultMessage: 'No se pudo actualizar el Centro de Costo.',
              });
          throw new Error(detalle);
        }
        return body;
      });
    })
    .then((body) => {
        // El segundo argumento es el centro de costos con sus relaciones (dirección, mercado,
        // gerencia y área). El ABM lo ignora; la grilla lo usa para refrescar las celdas derivadas.
        props.success(
          intl.formatMessage({
            id: 'cambioCentroCostoMovil.mensaje_exito',
            defaultMessage: 'Centro de Costo actualizado con Éxito!',
          }),
          body
        )
    })
    .catch((error) => {
      setGuardando(false);
      if (props.failure) props.failure(error.message);
      else console.log("Error:", error);
    });
  };

  return (<>
    <form className="form form-horizontal" ref={formRef} onSubmit={handleSubmit} id="form-centro-costo">
      <div className="col-md-12">
        <form noValidate autoComplete="off">
          <label className="col-md-5 label-control col-form-label text-left" htmlFor="fecha">
            Fecha de Cambio
          </label>
          <DatePicker
            id="fecha"
            name="fecha"
            selected={fecha}
            className="form-control date-picker-placeholder"
            dateFormat={LocaleFormat.getDatePickerFormat()}
            placeholderText ="DD/MM/AAAA"
            maxDate={moment()}
            minDate={moment().subtract(ConfigBusiness.get('moviles.centroCostos.diasHistoricoMaximo'), 'days')}
            onChange={(e)=>setFecha(e)}
          />
        </form>
      </div>
      <div className="col-md-12">
        <TextField
          id="razon"
          style={{ width: '100%' }}
          label="Razón del cambio"
          name="razon"
          value={razon}
          onChange={(e) => setRazon(e.target.value)}
        />
      </div>
      <div className="col-md-12">
        <TextField
          id="comentario"
          style={{ width: '100%' }}
          label="Comentario"
          name="comentario"
          value={comentario}
          onChange={(e) => setComentario(e.target.value)}
        />
      </div>
      <div className="col-md-12 mt-2 mb-2 text-center">
        <span class="text-danger">Se actualizará automáticamente el Centro de Costo.</span>
      </div>
      <div className="col-md-12">
        <div className="d-flex justify-content-center mt-2">
          <button type="submit" className="btn btn-primary mr-1" disabled={guardando}>
            <i className="fa fa-check-circle mr-1"></i>
            Actualizar
          </button>
          <button type="button" className="btn btn-danger" onClick={() => props.dismiss()}>
            <i className="fa fa-times-circle mr-1"></i>
            Cancelar
          </button>
        </div>
      </div>
    </form>
  </>
  );
};
export default CambioCentroCostoMovil;
